import { Button, Stack, Text, useMantineColorScheme } from "@mantine/core";
import { IconMoonStars, IconSun } from "@tabler/icons-react";

const ICON_SIZE = 16;
const ICON_STROKE = 2.5;

interface ThemeOption {
    value: "light" | "dark";
    label: string;
    icon: React.FC<{ size: number; stroke: number; color: string }>;
}

const themeOptions: ThemeOption[] = [
    {
        value: "light",
        label: "Light",
        icon: IconSun,
    },
    {
        value: "dark",
        label: "Dark",
        icon: IconMoonStars,
    },
];

export function ThemeControls() {
    const { colorScheme, setColorScheme } = useMantineColorScheme();

    return (
        <Stack gap="xs">
            <Text size="xs">Theme</Text>
            <Button.Group borderWidth={2}>
                {themeOptions.map(({ value, label, icon: Icon }) => (
                    <Button
                        key={value}
                        size="xs"
                        variant={colorScheme === value ? "filled" : "default"}
                        onClick={() => setColorScheme(value)}
                        aria-pressed={colorScheme === value}
                        aria-label={`Switch to ${label} theme`}
                        title={`${label} theme`}
                        leftSection={
                            <Icon
                                size={ICON_SIZE}
                                stroke={ICON_STROKE}
                                color={`var(--mantine-color-${colorScheme === value ? "primary-2" : "primary-3"})`}
                            />
                        }
                    >
                        {label}
                    </Button>
                ))}
            </Button.Group>
        </Stack>
    );
}
